import { isMock } from "@/lib/mock-flags";
import { sseClient } from "./sse-client";
import { mockNotificationsClient } from "./sse-mock";
import type { NotificationsClient } from "./types";

/** Cliente ativo escolhido pela flag VITE_MOCK_NOTIFICATIONS. */
export function getNotificationsClient(): NotificationsClient {
  return isMock("notifications") ? mockNotificationsClient : sseClient;
}

export type { NotificationsClient } from "./types";
